import React, { useEffect } from 'react';

const About: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-warm-100 py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-5xl font-elegant font-bold text-primary-800 mb-8 text-center">About Us</h1>
        <p className="text-xl text-secondary-700 mb-6 text-center">
          SoundX724 is dedicated to celebrating and promoting the rich heritage of Indian classical music. Our platform brings together artists, enthusiasts, and learners to experience the timeless beauty of music through live events, workshops, and educational resources.
        </p>
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-primary-700 mb-4">Our Mission</h2>
          <p className="text-secondary-700 text-lg mb-2">
            To foster a vibrant community that appreciates, preserves, and advances the traditions of Indian classical music.
          </p>
          <ul className="list-disc pl-6 text-secondary-700">
            <li>Host world-class concerts and recitals</li>
            <li>Provide music education and workshops</li>
            <li>Support emerging and established artists</li>
            <li>Promote cultural exchange and understanding</li>
          </ul>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-primary-700 mb-4">Our Story</h2>
          <p className="text-secondary-700 text-lg">
            Founded in 2023, SoundX724 was born from a passion for music and a desire to create a space where tradition meets innovation. Our team is made up of musicians, educators, and technologists who believe in the transformative power of music.
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-primary-700 mb-4">Contact Us</h2>
          <p className="text-secondary-700 text-lg mb-2">
            Have questions or want to get involved? Reach out to us at <a href="mailto:soundx724@gmail.com" className="text-primary-600 underline">soundx724@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
